import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="mt-20">

      <div className="*:min-h-[400px] *:rounded-2xl grid gap-2 md:grid-cols-2">
        <div
          className=" row-span-2"
          style={{
            backgroundImage: "url('https://picsum.photos/id/43/3000')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
        <div
          className=" md:block hidden "
          style={{
            backgroundImage: "url('https://picsum.photos/id/84/3000/1200')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
        <div className="flex flex-col justify-center gap-6 p-10 bg-dark text-light rounded-2xl">
          <p className="med-text text-justify leading-relaxed">
            <span
              className="inline-block med-text text-bright font-bold mr-2"
              style={{ lineHeight: 1.2 }}
            >
              Avinya Green Constructions,
            </span>
            founded by a dynamic IIM-A and IIT-D Alumnus, Structural Engineer
            and ex-Armed Forces officer, with a vibrant portfolio comprising
            commercial, residential and mixed use projects spread philosophy of
            innovation, sustainability, excellence in the real estate industry.
            across key cities in India. We breathe the and Our development model
            combines the legacy of excellence, trust, ownership and commitment
            to cutting-edge design and technology, rolled into one solid
            delivery.
          </p>
          <Link to={"/about"}>
            <div className="w-fit px-6 py-3 med-text font-semibold rounded-full text-bright bg-light hover:bg-bright hover:text-light transition-all duration-300 cursor-pointer">
              Learn More →
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
